var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Flex } from 'rebass';
var __TableRow = function (_a) {
    var forwardRef = _a.forwardRef, columns = _a.columns, data = _a.data, metadata = _a.metadata, highlighted = _a.highlighted, setUpdateByMouse = _a.setUpdateByMouse, index = _a.index, start = _a.start, setHighlightedRow = _a.setHighlightedRow, rowHeight = _a.rowHeight, size = _a.size, stripeSelected = _a.stripeSelected;
    var _b = React.useState(true), collapsed = _b[0], setCollapsed = _b[1];
    var Columns = React.Children.map(columns, function (column) {
        return React.cloneElement(column, {
            asHeader: false,
            data: data,
            highlighted: highlighted,
            index: index,
            metadata: metadata,
            collapsed: collapsed,
            onCollapse: setCollapsed,
        });
    });
    var selectRow = React.useCallback(function (setHighlightedRow, setUpdateByMouse) {
        setHighlightedRow(index);
        setUpdateByMouse(true);
    }, [index]);
    var invalidatableRef = React.useRef(null);
    React.useEffect(function () {
        // @ts-ignore The types of react-virtual don't reveal that this is in fact a RefCallback.
        // This is perfectly fine to keep, but could be replaced with react-virtual#55
        forwardRef(invalidatableRef.current);
    }, [invalidatableRef.current, collapsed]);
    return (React.createElement(Flex, { ref: invalidatableRef, className: "table-row", onClick: function () {
            selectRow(setHighlightedRow, setUpdateByMouse);
        }, px: 4, sx: __assign(__assign({ position: 'absolute', width: '100%', left: 0, top: 0, transform: "translateY(" + start + "px)", minHeight: rowHeight, boxSizing: 'border-box', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'neutral_2', '&:hover': {
                backgroundColor: 'neutral_1',
            } }, (stripeSelected && {
            '&:before': __assign({ content: '""', width: '4px', height: '100%', backgroundColor: 'primary_2', position: 'absolute', left: '0', borderRadius: '2px' }, (highlighted ? {} : { display: 'none' })),
        })), { '&:after': __assign({ content: '""', width: '100%', height: '100%', position: 'absolute', left: '0', zIndex: '-1', backgroundColor: 'neutral_1' }, (highlighted ? {} : { display: 'none' })) }) }, Columns));
};
export default React.memo(__TableRow);
